export default class RestApi{
    static URL = "http://api.holos.com.br/api";
    static URL_GETTHERAPIES = `${RestApi.URL}/CustomerAPI/GetTherapies`;
    static URL_GETPROFESSIONALDETAILSLIST = `${RestApi.URL}/ProfessionalAPI/GetProfessionalDetailsList`;

    static GetTherapies(){
        return fetch(`${RestApi.URL_GETTHERAPIES}`)
        .then((res) => res.json())
    }

    static GetProfessionalDetailsList(){
        return fetch(`${RestApi.URL_GETPROFESSIONALDETAILSLIST}`)
        .then((res) => res.json())
    }
}